import React, { Component } from 'react';
import './iamExKeTitle.css';

class IamExKeTitle extends Component {

  state = {

  };

  componentDidMount() {

  };

  render() {

    return (
      <div className="IamExKeTitlePage">
        IamExKeTitle
      </div>
    );
  };

};

export default IamExKeTitle;


// WEBPACK FOOTER //
// ./src/components/content/iamExplorer/iamExKeys/iamExKeTitle/iamExKeTitle.js